import { render, staticRenderFns } from "./StatementDetailComponent.vue?vue&type=template&id=132a7716"
import script from "./StatementDetailComponent.vue?vue&type=script&lang=js"
export * from "./StatementDetailComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports